export const mailRegex = /^(\w)+(\.\w+)*@(\w)+((\.\w+)+)$/;

